export enum TableHeadEnum {
    passwordName = 'passwordName',
    firstAccessedAt = 'firstAccessedAt',
    lastAccessedAt = 'lastAccessedAt',
    vaultName = 'vaultName',
    type = 'type',
    happenedAt = 'happenedAt'
}